<template>
    <section>
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                      <li class="m-nav__item">
                          <router-link :to="{name: 'home'}">
                              <span class="m-nav__link-text">
                    <i class="m-nav__link-icon la la-home"></i>
                              </span>
                          </router-link>
                      </li>
                      <li class="m-nav__separator">
                          >
                      </li>
                      <li class="m-nav__item">
                              <span class="m-nav__link-text">
                                  {{'authorizations_administration' | translate | titleize}}
                              </span>
                      </li>
              <li class="m-nav__separator">
                          >
                      </li>
                      <li class="m-nav__item">
                          <span class="m-nav__link-text">
                              {{'authorizations' | translate | titleize}}
                          </span>
                      </li>
                  </ul>
          </div>
        </div>
      </div>
      <div class="m-content" id="content">
        <div class="m-portlet m-portlet--mobile">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon">
                  <i class="flaticon-suitcase"></i>
                </span>
                <h3 class="m-portlet__head-text">
                  {{ 'registers' | translate | capitalize }}
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body" id="group-register">
            <div class="form-group m-form__group row container-register">
              <div :class="[{'has-danger': errors.has(`authorized_type`)}, 'col-lg-3']">
                <label for="authorized_type">{{'authorized_type' | translate | capitalize }}</label>
                <select name="authorized_type" id="authorized_type" v-model="autho.authorized_type_id" :class="{'form-control': true, 'error': errors.has('identification_type') } " disabled>
                  <option v-if="hideAuthType(auth_type)" v-for="auth_type in authorized_types" :key="auth_type.id" :value="auth_type.id">
                    {{ auth_type.name }}
                  </option>
                </select>
                <span v-show="errors.has('authorized_type')" class="m-form__help m--font-danger"> {{errors.first('authorized_type')}} </span>
              </div>
              <div v-if="idx_department != -1" v-show="false" :class="[{'has-danger': errors.has(`department_auth`)}, 'col-lg-3']">
                <label for="department_auth">{{'department' | translate | capitalize }}</label>
                <select name="department_auth" id="department_auth" v-model="autho.department_id" :class="{'form-control': true, 'error': errors.has('department_auth') } ">
                  <option value="">{{ 'select_an_option' | capitalize }}</option>
                  <option v-for="department in departments" :key="department.id" :value="department.id">
                    {{ department.name }}
                  </option>
                </select>
                <span v-show="errors.has('department_auth')" class="m-form__help m--font-danger"> {{errors.first('department_auth')}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`access_profile`)}, 'col-lg-3']">
                <label for="access_profile">{{'access_profile' | translate | capitalize }}</label>
                <select name="access_profile" id="access_profile" v-model="autho.access_profile_id" @change="showAccessProfile; changeAccesProfile(autho.access_profile_id)" :class="{'form-control': true, 'error': errors.has('identification_type') }" v-validate="'required'" >
                  <option value="">{{ 'select_an_option' | capitalize }}</option>
                  <option v-show="autho.authorized_type_id === access_profile.authorized_type_id && autho.department_id === access_profile.department_id" v-for="access_profile in access_profiles.filter(access_profile => access_profile.is_personalized === 0 || access_profile.id === autho.access_profile_id)" :key="access_profile.id" :value="access_profile.id">
                    {{ access_profile.is_personalized === 0 ? access_profile.name : 'personalized' | capitalize }}
                  </option>
                  <option value="-1" v-if="autho.access_profile_personalized==0" >{{ 'custom' | capitalize }}</option>
                </select>
                <span v-show="errors.has('access_profile')" class="m-form__help m--font-danger"> {{errors.first('access_profile')}} </span>
              </div>
              <div v-show="(autho.access_profile_id !== '-1')" :class="[{'has-danger': errors.has(`see_access_profile`)}, 'col-lg-1']">
                <label for="see_access_profile">&emsp;</label><br>
                <a href="#" @click.prevent="infoModal" class="btn btn-success m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#access_profile_modal">
                  <i class="la la-eye"></i>
                </a>
              </div>
              <div v-show="(autho.access_profile_id === '-1')" class="col-lg-3 element-register">
                <label  >&nbsp;</label><br>
                <a href="#" class="btn btn-success m-btn m-btn--icon m-btn--wide" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#access_profile_modal" @click.prevent="showAccessProfileModal">
                  <span>
                    <i class="la la-calendar"></i>
                    <span>{{ 'access_data' | capitalize }}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <form class="m-form m-form--state">
          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
              <div class="form-group m-form__group row">
                <div :class="[{'has-danger': errors.has(`identification_number`)}, 'col-lg-3']">
                  <label :for="`identification_number`">{{'identification_number' | translate | capitalize }}</label>
                  <input type="text" data-vv-as="identification_number" :id="`identification_number`" v-model="autho.identification_number" :name="`identification_number`" :placeholder="'enter_identification_number' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_num|min:4|max:15'" :readonly="autho.is_dni_generated === 0 ? true : false" @keyup="uniqueIdentificationNumber(autho.identification_number, idx)">
                  <span v-show="errors.has(`identification_number`)" class="m-form__help m--font-danger"> {{errors.first(`identification_number`)}} </span>
                </div>
                <div class="col-lg-3" :class="{'has-danger': errors.has(`identification_type`)}">
                  <label :for="`identification_type`">{{ 'identification_type' | translate | capitalize }}</label>
                  <select data-vv-as="identification_type" :id="`identification_type`" disabled v-model="autho.identification_type" v-validate="'required'" :name="`identification_type`" :class="{'form-control': true, 'error': errors.has(`identification_type`) } ">
                    <option value="">
                      {{ 'select_an_option' | translate | capitalize }}
                    </option>
                    <option v-for="identification in identification_types" :value="identification.id" :key="identification.id">
                      {{ identification.name }}
                    </option>
                  </select>
                  <span v-show="errors.has(`identification_type`)" class="m-form__help m--font-danger"> {{errors.first(`identification_type`)}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`first_name`)}, 'col-lg-3']">
                  <label :for="`first_name`">{{'first_name' | translate | capitalize }}</label>
                  <input data-vv-as="first_name" type="text" :id="`first_name`" v-model="autho.first_name" :name="`first_name`" :placeholder="'enter_first_name' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_spaces|min:2|max:50'">
                  <span v-show="errors.has(`first_name`)" class="m-form__help m--font-danger"> {{translateErrorMessage('first_name',errors.first(`first_name`))}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`last_name`)}, 'col-lg-3']">
                  <label :for="`last_name`">{{'last_name' | translate | capitalize }}</label>
                  <input data-vv-as="last_name" type="text" :id="`last_name`" v-model="autho.last_name" :name="`last_name`" :placeholder="'enter_last_name' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_spaces|min:2|max:50'">
                  <span v-show="errors.has(`last_name`)" class="m-form__help m--font-danger"> {{translateErrorMessage('last_name',errors.first(`last_name`))}} </span>
                </div>
              </div>
  
              <div class="form-group m-form__group row">
                <div :class="[{'has-danger': errors.has(`start_date`)}, 'col-lg-3']">
                  <label :for="`start_date`">{{'start_date' | translate | capitalize }}</label>
                  <s-date-time-picker :id="'start_date'" :name="'start_date'" v-model="autho.start_date" :options="config.start" :placeholder="'AAAA-MM-DD'" v-validate="'required'" @empty="autho.start_date = $event" @input="startDate(autho.start_date)"></s-date-time-picker>
                  <span v-show="errors.has(`start_date`)" class="m-form__help m--font-danger"> {{errors.first(`start_date`)}} </span>
                </div>
                <div v-show="autho.authorized_type_id !== 2 && autho.authorized_type_id !== 3 && autho.undefined_date == 1" class="col-lg-3">
                  <div class="m-checkbox-inline m-checkbox-inline-form-wizard"><br>
                    <label class="m-checkbox checkbox-form-wizard">
                        {{ 'undefined_date' | capitalize }}
                      <input type="checkbox" name="undefined" v-model="autho.undefined_date">
                      <span></span>
                    </label>
                  </div>
                </div>
                <div v-if="!autho.undefined_date" :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-3']">
                  <label :for="`end_date`">{{'end_date' | translate | capitalize }}</label>
                  <s-date-time-picker :id="'end_date'" :name="'end_date'" v-model="autho.end_date" :options="config.end" :placeholder="'AAAA-MM-DD'" v-validate="'required'" @empty="autho.end_date = $event" @input="endDate(autho.end_date)"></s-date-time-picker>
                  <span v-show="errors.has(`end_date`)" class="m-form__help m--font-danger"> {{errors.first(`end_date`)}} </span>
                </div>
                <div v-if="(autho.authorized_type_id === 4)" :class="[{'has-danger': errors.has(`relationship`)}, 'col-lg-3']">
                  <label :for="`relationship`">{{'relationship' | translate | capitalize }}</label>
                  <input data-vv-as="relationship" type="text" :id="`relationship`" v-model="autho.relationship" :name="`relationship`" :placeholder="'enter_relationship' | translate | capitalize" class="form-control m-input" v-validate="'required|alpha_spaces|min:2|max:50'">
                  <span v-show="errors.has(`relationship`)" class="m-form__help m--font-danger"> {{translateErrorMessage('relationship',errors.first(`relationship`))}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`email`)}, 'col-lg-3']">
                  <label :for="`email`">{{'email' | translate | capitalize }}</label>
                  <input data-vv-as="email" class="form-control m-input" type="text" :id="`email`" v-model="autho.email" :name="`email`" v-validate="is_operator ? 'required|email|max:100|uniqueEmail' : autho.biometric ? 'required|email|max:100|uniqueEmail' : 'email||min:5|max:100|uniqueEmail'" :placeholder="'enter_email' | translate | capitalize" :disabled="checkdisabled === true">
                  <span v-show="errors.has(`email`)" class="m-form__help m--font-danger"> {{translateErrorMessage('email',errors.first(`email`))}} </span>
                </div>
                <div :class="[{'has-danger': errors.has(`observations`)}, 'col-lg-6']">
                  <label :for="`observations`">{{'observations' | translate | capitalize }}</label>
                  <textarea data-vv-as="observations" class="form-control m-input" :id="`observations`" v-model="autho.observations" :name="`observations`" v-validate="'min:5|max:200'" :placeholder="'enter_observation' | translate | capitalize">
                  </textarea>
                  <span v-show="errors.has(`observations`)" class="m-form__help m--font-danger"> {{translateErrorMessage('observations',errors.first(`observations`))}} </span>
                </div>
                <div class="col-lg-3">
                  <label>&nbsp;</label><br>
                  <a v-if="!is_cargo" href="" v-tooltip="messageCarTooltip" class="buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_cars_modal">
                    <i class="fa fa-car"></i>
                    <span v-if="own_cars.length > 0" class="badge badge-notification">{{own_cars.length}}</span>
                  </a>
                  <a v-else href="" v-tooltip="messageTruckTooltip" :class="['btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_cargo_cars_modal">
                    <i class="fa fa-truck"></i>
                    <span v-if="Object.keys(cargo_cars).length > 0" class="badge badge-notification">{{Object.keys(cargo_cars).length > 0 ? 1 : ''}}</span>
                  </a>
                  <label>&nbsp;</label>
                  <a  v-show="shard.allow_credentials_assigned === 1" href="" v-tooltip="messageCredentialTooltip" :class="[{'btn-primary': !credentialErrors},{'btn-danger': credentialErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_credentials_modal">
                    <i class="fa fa-address-card"></i>
                    <span v-if="authorized_credentials.length > 0" class="badge badge-notification">{{authorized_credentials.length}}</span>
                  </a>
                  <label>&nbsp;</label>
                  <a v-show="showExpirations && !autho.undefined_date" href="" v-tooltip="messageDocumentTooltip" :class="[{'btn-primary': !expirationErrors},{'btn-danger': expirationErrors},'buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill']" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#add_expiration_modal" >
                    <i class="fa fa-calendar-times-o"></i>
                  </a>
                </div>
              </div>
  
              <div class="form-group m-form__group">
                <div class="form-group m-form___group row details_container">
                  <div :class="[{'has-danger': errors.has(`company_origin`)}, 'col-lg-3']" v-if="autho.authorized_type_id === 6 || autho.authorized_type_id === 7">
                    <label :for="`company_origin`">{{'company_origin' | translate | capitalize }}</label>
                    <input data-vv-as="company_origin" class="form-control m-input" type="text" :id="`company_origin`" v-model="autho.company_origin" :name="`company_origin`" v-validate="autho.authorized_type_id === 6 || autho.authorized_type_id === 7 ? 'min:2|max:100|required' : 'min:2|max:100'" :placeholder="'enter_company_origin' | translate | capitalize">
                    <span v-show="errors.has(`company_origin`)" class="m-form__help m--font-danger"> {{translateErrorMessage('company_origin',errors.first(`company_origin`))}} </span>
                  </div>
                  <div>
                    <label>&nbsp;</label><br>
                    <a v-if="is_cargo_prop === 1" href="#" class="btn btn-danger" @click.prevent="removeAuthorization">
                      <!-- <span> -->
                        <i class="la la-warning"></i>
                        <span>
                        {{ 'remove_authorization' | capitalize }}
                        </span>
                      <!-- </span> -->
                    </a>
                  </div>
                </div>
  
                <div class="form-group m-form___group row">
                  <div v-if="showVisited && authorized_type_id > 2" class="form-control checks col-lg-3">
                    <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="is_responsible">
                        {{ 'is_responsible' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                  <div v-if="showOperator" class="form-control checks col-lg-3">
                    <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="is_operator" :disabled="autho.profile_operator != null">
                        {{ 'is_operator' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                  <div v-if="showOwnFleet" v-show="false" class="form-control checks col-lg-3">
                    <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="autho.own_fleet">
                        {{ 'is_own_fleet' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                  <div v-show="showBiometric == 'true'" class="form-control checks col-lg-3">
                    <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="autho.biometric" :disabled="hasTemplate" @click="checkBiometricsMail(autho.email)">
                        {{ 'biometric' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                  <div v-if="isTraining && autho.authorized_type_id !== 3" class="form-control checks col-lg-3">
                    <div class="m-checkbox-list m-checkbox-inline-form-wizard">
                      <label class="m-checkbox">
                        <input type="checkbox" v-model="autho.is_telecommuting">
                        {{ 'is_telecommuting' | translate | capitalize }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group m-form__group row container-hide">
                  <div v-show="is_responsible" :class="[{'has-danger': errors.has(`autho.position`)}, 'col-lg-3']">
                    <label :for="`position`">{{'position' | translate | capitalize }}</label>
                    <input data-vv-as="position" class="form-control m-input" type="text" :id="`position`" v-model="autho.position" :name="`position`" v-validate="'min:3|max:50'" placeholder="">
                    <span v-show="errors.has(`autho.position`)" class="m-form__help m--font-danger"> {{translateErrorMessage('position',errors.first(`autho.position`))}} </span>
                  </div>
                  <div v-if="is_operator" :class="[{'has-danger': errors.has(`profile_operator`)}, 'col-lg-3']">
                    <label :for="`profile_operator`">{{'profile_operator' | translate | capitalize }}</label>
                    <select data-vv-as="profile_operator" :id="`profile_operator`" v-model="autho.profile_operator" v-validate="is_operator ?'required' : ''" :name="`profile_operator`" :class="{'form-control m-input': true, 'error': errors.has(`profile_operator`)}">
                      <option value="">{{ 'select_an_option' | translate | capitalize }}</option>
                      <option v-for="profile in profiles" :value="profile.id" :key="profile.id">
                        {{ profile.name | translate | capitalize}}
                      </option>
                    </select>
                    <span v-show="errors.has(`profile_operator`)" class="m-form__help m--font-danger"> {{translateErrorMessage('profile_operator',errors.first(`profile_operator`))}} </span>
                  </div>
                </div>
  
                <div v-if="is_cargo_prop && display_departure_order" class="m-portlet m-portlet--mobile">
                  <div class="m-portlet__body">
                    <div class="form-group m-form___group row">
                      <label :for="`departure_order`" class="col-2 col-form-label">{{'departure_order' | translate | capitalize }}</label>
                      <div class="col-6">
                        <input type="text" data-vv-as="departure_order" :id="`departure_order`" v-model="departure_order" :name="`departure_order`" :placeholder="'enter_departure_order' | translate | capitalize" class="form-control m-input" v-validate="'alpha_num|min:4|max:10'" :readonly="generate_departure ? false : true">
                        <span v-show="errors.has(`departure_order`)" class="m-form__help m--font-danger"> {{translateErrorMessage('departure_order',errors.first(`departure_order`))}} </span>
                      </div>
                      <div v-if="generate_departure" class="col-4">
                        <a href="" class="btn btn-success" @click.prevent="departureOrder">
                          {{ 'generate_departure_order' | capitalize }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
  
              </div>
            </div>
          </div>
  
          <div class="actions">
            <button class="btn btn-secondary" @click.prevent="back">{{ 'cancel' | translate | capitalize }}</button>
            <button class="btn btn-primary" @click.prevent="validate">{{ 'save' | translate | capitalize }}</button>
          </div>
        </form>
      </div>
      <s-modal  v-if="(autho.access_profile_id !== '' && autho.access_profile_id !== '-1')"  id="access_profile_modal" :title="'create_access_profile' | translate | capitalize">
        <s-access-profile v-show="!modal_access_day" slot="body" :data="access_profile_view" :edit_outside="edit_outside" :create_outside="create_access_days" :access_profile_responsible="access_profile_responsible" :create_outside_group="true" :view="!create_access_days" :show_department="false"></s-access-profile>
        <s-access-day v-show="modal_access_day" slot="body" v-bind:open_outside="!edit_outside" :data="access_day_view" v-bind:view="!edit_outside" :create_outside="create_access_days" modal="true"></s-access-day>
      </s-modal>
      <s-modal v-if="!is_cargo" id="add_cars_modal" :title="'vehicles' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
        <div class="modal-body" slot="body">
          <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
            <div class="form-group m-form__group">
              <div v-for="(car, index) in  own_cars" :key="index" class="row">
                <div class="col-lg-9">
                  <label :for="`plate`">{{'plate' | translate | capitalize }}</label>
                  <input class="form-control m-input" type="text" data-vv-as="plate"  :id="`plate_${index}`" v-model="car.license_plate" :name="`plate_${index}`" v-validate="'required|alpha_dash|min:5|max:10'" :placeholder="'enter_plate' | translate | capitalize">
                  <span v-show="errors.has(`plate_${index}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('plate',errors.first(`plate_${index}`))}} </span>
                </div>
                <div class="col-lg-3">
                  <label for="">&emsp;</label>
                  <a href="" class="btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="dropCar(index)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </div>
            </div>
            <a href="" class="btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="addCar">
              <i class="fa fa-plus"></i>
            </a>
          </div>
          <div class="actions">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeForm">
              {{ 'close' | translate | capitalize }}
            </button>
          </div>
        </div>
      </s-modal>
      <s-modal v-if="is_cargo" id="add_cargo_cars_modal" :title="'vehicle_cargo' | translate | capitalize" :close_header="true">
        <section slot="body">
          <div class="modal-body">
            <div class="form-group m-form__group row">
              <div :class="[{'has-danger': errors.has(`vehicle_type_id`)}, 'col-lg-6 container-vehicle']">
                <label :for="`vehicle_type_id`">{{'vehicle_type' | translate | capitalize }}</label>
                <select :name="`vehicle_type_id`" :id="`vehicle_type_id`" v-model="cargo_cars.vehicle_type_id" v-validate="'required'" :class="{'form-control': true, 'error': errors.has(`vehicle_type_id`) }" @change="cargo_vehicles(cargo_cars.vehicle_type_id)">
                  <option value="">{{ 'select_an_option' | capitalize }}</option>
                  <option v-for="(cargo_vehicle, idx) in cargo_vehicle_type" :key="idx" :value="cargo_vehicle.id">
                    {{ cargo_vehicle.name }}
                  </option>
                </select>
                <span v-show="errors.has(`vehicle_type_id`)" class="m-form__help m--font-danger"> {{translateErrorMessage('vehicle_type',errors.first(`vehicle_type_id`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`cargo_type_vehicle_type`)}, 'col-lg-6 container-vehicle']">
                <label :for="`cargo_type_vehicle_type`">{{'vehicle_type' | translate | capitalize }}</label>
                <select :data-vv-as="'vehicle_type' | translate" :name="`cargo_type_vehicle_type`" :id="`cargo_type_vehicle_type`" v-model="cargo_cars.cargo_vehicle_type" v-validate="'required'" :class="{'form-control': true, 'error': errors.has(`cargo_type_vehicle_type`) }">
                  <option value="">{{ 'select_an_option' | capitalize }}</option>
                  <option v-if="hideCargoType(cargo_cars.vehicle_type_id, cargo_vehicle.type)" v-for="(cargo_vehicle, idx) in cargo_type_vehicles" :key="idx" :value="cargo_vehicle.name">
                    {{ cargo_vehicle.name | capitalize }}
                  </option>
                </select>
                <span v-show="errors.has(`cargo_type_vehicle_type`)" class="m-form__help m--font-danger"> {{translateErrorMessage('vehicle_type',errors.first(`cargo_type_vehicle_type`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`truck_license_plate`)}, 'col-lg-6 container-vehicle']">
                <label :for="`truck_license_plate`">{{'truck_license_plate' | translate | capitalize }}</label>
                <input :name="`truck_license_plate`" :id="`truck_license_plate`" v-validate="'required|min:6|max:10'" v-model="cargo_cars.truck_license_plate" class="form-control m-input">
                <span v-show="errors.has(`truck_license_plate`)" class="m-form__help m--font-danger"> {{translateErrorMessage('truck_license_plate',errors.first(`truck_license_plate`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`cargo_order`)}, 'col-lg-6 container-vehicle']">
                <label :for="`cargo_order`">{{'cargo_order' | translate | capitalize }}</label>
                <input :name="`cargo_order`" :id="`cargo_order`" v-model="cargo_cars.cargo_order" v-validate="'required|alpha_num|min:1|max:10'" class="form-control m-input">
                <span v-show="errors.has(`cargo_order`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_order',errors.first(`cargo_order`))}} </span>
              </div>
              <div v-if="is_articulate" :class="[{'has-danger': errors.has(`trailer_license_plate`)}, 'col-lg-6 container-vehicle']">
                <label :for="`trailer_license_plate`">{{'trailer_license_plate' | translate | capitalize }}</label>
                <input :name="`trailer_license_plate`" :id="`trailer_license_plate`" v-model="cargo_cars.trailer_license_plate" v-validate="'required|min:6|max:10'" class="form-control m-input">
                <span v-show="errors.has(`trailer_license_plate`)" class="m-form__help m--font-danger"> {{translateErrorMessage('trailer_license_plate',errors.first(`trailer_license_plate`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`cargo_vehicle_brand`)}, 'col-lg-6 container-vehicle']">
                  <label :for="`cargo_vehicle_brand`">{{'cargo_vehicle_brand' | translate | capitalize }}</label>
                  <input :data-vv-as="'cargo_vehicle_brand' | translate" :name="`cargo_vehicle_brand`" :id="`cargo_vehicle_brand`" v-model="cargo_cars.cargo_vehicle_brand" v-validate="'alpha|min:5|max:20'" class="form-control m-input">
                  <span v-show="errors.has(`cargo_vehicle_brand`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_brand',errors.first(`cargo_vehicle_brand`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`cargo_vehicle_color`)}, 'col-lg-6 container-vehicle']">
                <label :for="`cargo_vehicle_color`">{{'cargo_vehicle_color' | translate | capitalize }}</label>
                <input :data-vv-as="'cargo_vehicle_color' | translate" :name="`cargo_vehicle_color`" :id="`cargo_vehicle_color`" v-model="cargo_cars.cargo_vehicle_color" v-validate="'alpha|min:5|max:20'" class="form-control m-input">
                <span v-show="errors.has(`cargo_vehicle_color`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_color',errors.first(`cargo_vehicle_color`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`cargo_vehicle_model`)}, 'col-lg-6 container-vehicle']">
                <label :for="`cargo_vehicle_model`">{{'cargo_vehicle_model' | translate | capitalize }}</label>
                <input :data-vv-as="'cargo_vehicle_model' | translate" :name="`cargo_vehicle_model`" :id="`cargo_vehicle_model`" v-model="cargo_cars.cargo_vehicle_model" v-validate="'min:5|max:20'" class="form-control m-input">
                <span v-show="errors.has(`cargo_vehicle_model`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_model',errors.first(`cargo_vehicle_model`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`carrier_company`)}, 'col-lg-6 container-vehicle']">
                <label :for="`carrier_company`">{{'carrier_company' | translate | capitalize }}</label>
                <input :data-vv-as="'carrier_company' | translate" :name="`carrier_company`" :id="`carrier_company`" v-model="cargo_cars.carrier_company" v-validate="'min:5|max:20'" class="form-control m-input">
                <span v-show="errors.has(`carrier_company`)" class="m-form__help m--font-danger"> {{translateErrorMessage('carrier_company',errors.first(`carrier_company`))}} </span>
              </div>
              <div :class="[{'has-danger': errors.has(`container_number`)}, 'col-lg-6 container-vehicle']">
                <label :for="`container_number`">{{'container_number' | translate | capitalize }}</label>
                <input :name="`container_number`" :id="`container_number`" v-model="cargo_cars.container_number" v-validate="'numeric'" class="form-control m-input">
                <span v-show="errors.has(`container_number`)" class="m-form__help m--font-danger"> {{translateErrorMessage('container_number',errors.first(`container_number`))}} </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" id="add_cargo_cars_modal">
              {{ 'save' | capitalize }}
            </button>
          </div>
        </section>
      </s-modal>
      <s-modal id="add_credentials_modal" :title="'credentials' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
        <div class="modal-body" slot="body">
          <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
            <div class="form-group m-form__group">
              <div v-for="(auto_credential, idx) in  authorized_credentials" :key="idx" class="row">
                <div class="col-lg-9">
                  <div :class="[{'has-danger': errors.has(`credential_${idx}`)}]">
                    <label :for="`credential_${idx}`">{{ 'credential' | translate | capitalize }}</label>
                    <select :id="`credential_${idx}`" v-model="auto_credential.credential_id" :name="`credential_${idx}`" :class="['form-control', {'error': errors.has(`credential_${idx}`)}]" v-validate="`validateAccessCredential:${idx}`" >
                      <option value="0">
                        {{ 'select_an_option' | translate | capitalize }}
                      </option>
                      <option  v-for="c in access_credentials" :value="c.id" :key="c.id">
                        {{ c.name }}
                      </option>
                    </select>
                    <span v-show="errors.has(`credential_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('credential',errors.first(`credential_${idx}`))}} </span>
                  </div>
                  <div :class="[{'has-danger': errors.has(`value_credential_${idx}`)}]">
                    <label :for="`value_credential_${idx}`">{{'value_credential' | translate | capitalize }}</label>
                    <input data-vv-as="credential" type="text" :id="`value_credential_${idx}`" v-model="auto_credential.value" :name="`value_credential_${idx}`" :placeholder="'enter_value_credential' | translate | capitalize" class="form-control m-input" v-validate="'required|numeric|max:15'" @keyup="uniqueCredential(auto_credential.value, auto_credential.credential_id, idx)" :readonly="parseInt(auto_credential.credential_id) === 0 ? true : false">
                    <span v-show="errors.has(`value_credential_${idx}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('value_credential',errors.first(`value_credential_${idx}`))}} </span>
                  </div>
                </div>
                <div class="col-lg-3">
                  <label for="">&emsp;</label>
                  <a href="" class="btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="dropCredential(idx)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </div>
            </div>
            <a href="" class="btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill" @click.stop.prevent="addCredential">
              <i class="fa fa-plus"></i>
            </a>
          </div>
          <div class="actions">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeForm">
              {{ 'close' | translate | capitalize }}
            </button>
          </div>
        </div>
      </s-modal>
      <s-modal v-if="showExpirations && !autho.undefined_date" id="add_expiration_modal" :title="'expirations' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
        <div class="modal-body" slot="body">
          <div class="m-scrollable" data-scrollbar-shown="true" data-scrollable="true" data-max-height="200">
            <div class="form-group m-form__group">
              <div class="form-group m-form__group row">
                <div class="row doc_expiration" v-for="(docs, k) in doc_types" :key="k">
                  <div class="col-lg-12" :class="{'has-danger': errors.has(`expires_doc_${k}`)}">
                    <label :for="`expires_doc_${k}`">{{ docs.document.name | translate | capitalize }}</label>
                      {{expirationDate(doc_types)}}
                    <s-date-time-picker v-model="autho.doc_auth_types[k].value" @input="docExpiration(docs.id, k, $event)" :options="config_expiration" v-validate="docs.required === 1 ? 'required' : ''" :data-vv-as='docs.document.name' :name="`expires_doc_${k}`" :id="`expires_doc_${k}`" :alias="docs.document.name" :placeholder="'DD-MM-YYYY'" ></s-date-time-picker>
                    <span v-show="errors.has(`expires_doc_${k}`)" class="m-form__help m--font-danger"> {{errors.first(`expires_doc_${k}`)}} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeForm"  >
                {{ 'close' | translate | capitalize }}
              </button>
            </div>
          </div>
        </div>
      </s-modal>
  
  
      <!-- <s-modal v-if="!group_register && !authorization[tab_validator].undefined_date" id="add_expiration_modal" :title="'expirations' | translate | capitalize" :close_header="true" :size="'modal-sm modal-dialog-centered'">
        <div class="modal-body" slot="body">
          <div class="form-group m-form__group">
            <div class="form-group m-form__group row">
              <! --<div class="row doc_expiration space-row-container" v-if="show_expirations" v-for="(docs, k) in authorization[tab_validator].doc_types" :key="k">
                <div class="col-lg-12" :class="{'has-danger': errors.has(`expires_doc_${k}`)}">
                  <label :for="`expires_doc_${k}`">{{ docs.document.name | translate | capitalize }}</label>
                  <s-date-time-picker v-model="authorization[tab_validator].doc_auth_types[k].value" @input="docExpiration(docs.id, tab_validator, k, $event)" :options="config_expiration" v-validate="docs.required === 1 ? 'required' : ''" :data-vv-as='docs.document.name' :name="`expires_doc_${k}`" :id="`expires_doc_${k}`" :alias="docs.document.name" :placeholder="'DD-MM-YYYY'"></s-date-time-picker>
                  <span v-show="errors.has(`expires_doc_${k}`)" class="m-form__help m--font-danger"> {{errors.first(`expires_doc_${k}`)}} </span>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeForm"  >
              {{ 'close' | translate | capitalize }}
            </button>
          </div>
        </div>
      </s-modal> -->
  
  
      <s-modal v-if="autho.access_profile_id === '-1'" id="access_profile_modal" :title="'create_access_profile' | translate | capitalize">
        <s-access-profile v-show="!modal_access_day" slot="body" :data="access_profile_view"   v-bind:same_dates="same_dates" :auto="autho" :create_outside="true"  :create_outside_group="false" :not_visualize="false" :view="false" :id_authType="'auth_form_wizard'" :id_department="'department_form_wizard'" :id_cancel="'btn-cancel-form-wizard'" :id_control_point="'control_points'" :access_profile_responsible="access_profile_responsible" :data_default="true"></s-access-profile>
        <s-access-day v-show="modal_access_day" slot="body" :open_outside="true"  :view="false" :create_outside="true" :data="autho" :array_in_auth="true" :modal="true"></s-access-day>
      </s-modal>
    </section>
  </template>
  
  <script>
  import { Validator } from 'vee-validate'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import SModal from '@/components/layout/modal/Modal.vue'
  import SAccessDay from '@/components/admin/access_day/New.vue'
  import SAccessProfile from '@/components/admin/access_profiles/New.vue'
  import SFormContent from '@/components/admin/authorization/FormContent.vue'
  import service from '@/services/superaccess'
  import STimePicker from '@/components/layout/timepicker/TimePicker.vue'
  export default {
    components: { STimePicker, SModal, SAccessProfile, SAccessDay, SFormContent },
    props: {
      is_cargo_prop: { type: Number, required: false, default: 0 }
    },
    data () {
      return {
        autho: {
          first_name: '',
          own_cars: [],
          authorized_credentials: [],
          tab_validator: 0,
          own_fleet: false,
          profile_operator: '',
          access_day: [],
          identification_number: '',
          doc_auth_type: '',
          is_dni_generated: ''
        },
        config_expiration: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        doc_types: [],
        authorized_typeid: '',
        undefined_value: '',
        same_dates: false,
        authorized_types: [],
        profiles: [],
        access_credentials: [],
        identification_types: [],
        access_profile_responsible: {},
        visited: [],
        departments: [],
        access_profiles: [],
        own_cars: [],
        authorized_credentials: [],
        create_access_days: false,
        access_profile_view: {},
        access_day_view: {},
        show_expirations: false,
        is_cargo: false,
        is_responsible: false,
        portal_operator: false,
        is_operator: false,
        cargo_cars: {},
        is_articulate: false,
        departure_order: '',
        generate_departure: false,
        disabled: 0,
        display_departure_order: false,
        idx_department: 0,
        cargo_vehicle_type: [],
        cargo_type_vehicles: [{ name: 'van', type: 'simple' }, { name: 'wagon', type: 'simple' }, { name: 'camion', type: 'simple' }, { name: 'truck', type: 'articulate' }, { name: 'mini_truck', type: 'articulate' }],
        config: {
          start: {
            format: 'yyyy-mm-dd',
            minView: 2,
            startDate: moment().format('YYYY-MM-DD'),
            autoclose: true,
            pickerPosition: 'bottom-left'
          },
          end: {
            format: 'yyyy-mm-dd',
            minView: 2,
            startDate: moment().format('YYYY-MM-DD'),
            autoclose: true,
            pickerPosition: 'bottom-left'
          }
        },
        edit_outside: false,
        validate_email: true,
        showBiometric: false,
        hasTemplate: false,
        isTraining: false,
        // range_time: '',
        messageCarTooltip: this.$options.filters.capitalize('edit_vehicles'),
        messageTruckTooltip: this.$options.filters.capitalize('edit_truck_vehicles'),
        messageCredentialTooltip: this.$options.filters.capitalize('edit_credentials_value'),
        messageDocumentTooltip: this.$options.filters.capitalize('edit_documents_expiration')
      }
    },
    computed: {
      ...mapGetters({ modal_access_day: 'getModalAccessDay', modal_access_profile: 'getStatusAccessProfileModal', access_day: 'getAccessDay', access_profile_data: 'getAccesProfile', shard: 'getUserShard' }),
      expirationErrors () {
        let result = false
        if (this.errors.items.length > 0) {
          this.errors.items.forEach(er => {
            if (er.field.startsWith('expires_doc')) result = true
          })
        }
        return result
      },
      checkdisabled () {
        if (this.autho.email === '') {
          this.disabled = 1
          return false
        }
        if (this.autho.is_operator && this.disabled !== 1) {
          return true
        }
      },
      showVisited () {
        if (this.authorized_types.length > 0) {
          const auth_type = this.authorized_types.find(auth => auth.id === this.autho.authorized_type_id)
          return auth_type ? auth_type.is_responsible === 1 : false
        }
      },
      showOperator () {
        if (this.authorized_types.length > 0) {
          const auth_type = this.authorized_types.find(auth => auth.id === this.autho.authorized_type_id)
          return auth_type ? auth_type.portal_operator === 1 : false
        }
      },
      showOwnFleet () {
        if (this.authorized_types.length > 0) {
          const auth_type = this.authorized_types.find(auth => auth.id === this.autho.authorized_type_id)
          return auth_type ? auth_type.own_fleet === 1 : false
        }
      },
      credentialErrors () {
        let result = false
        if (this.errors.items.length > 0) {
          this.errors.items.forEach(er => {
            if (er.field.startsWith('value_credential')) result = true
          })
        }
        return result
      },
      showExpirations () {
        const idx = this.authorized_types.findIndex(auth => auth.id === this.autho.authorized_type_id)
        if (idx !== -1 && this.authorized_types[idx].documents.length === 0) return false
        return true
      },
      changeUndefined () {
        return this.autho.undefined_date
      }
    },
    methods: {
      ...mapActions(['retrieveData', 'showAuthorization', 'setStatusEditAccessDay', 'editAuthorization', 'generateDepartureOrder', 'changeAuthorization', 'setStatusAccessProfileModal', 'setModalAccessDay', 'setDataAccessProfile', 'setStatusRefreshForm', 'getStateBiometric', 'checkPersonTemplate']),
      ...mapMutations(['setValidateEmail']),
      validateAccessCredential () {
        const validateAccessCredential = (value, args) => {
          let result = true
          this.authorized_credentials.forEach((element, idx) => {
            if (element.credential_id === parseInt(value) && idx !== parseInt(args[0])) result = false
          })
          return {
            valid: result,
            data: {
              message: this.$options.filters.capitalize(this.$options.filters.translate('credential_has_been_taken'))
            }
          }
        }
        Validator.extend('validateAccessCredential', {
          validate: validateAccessCredential,
          getMessage: (field, params, data) => {
            return data.message
          }
        })
      },
      uniqueEmail (email, identification) {
        this.setValidateEmail(true)
        if (email !== undefined && identification !== undefined && email.trim().length > 0 && identification.trim().length > 0) {
          service.post('/api/person/check-email', this.$store, { email: email, identification_number: identification })
            .then((response) => {
              this.validate_email = response.data.valid
              this.setValidateEmail(response.data.valid)
            })
        }
        return this.validate_email
      },
      hideAuthType (value) {
        if (this.is_cargo_prop === 0 && value.is_cargo !== 0) return false
        return true
      },
      hideCargoType (id, type) {
        let cargo_vehicle_type = this.cargo_vehicle_type.find(cvt => cvt.id === id)
        if (cargo_vehicle_type.name === type) return true
        return false
      },
      changeAccesProfile (id) {
        // autho.authorized_type_id === access_profile.authorized_type_id && autho.department_id === access_profile.department_id
        if (id === '-1') this.setStatusRefreshForm(true)
      },
      showAccessProfileModal () {
        // if (this.visited_to !== '') {
        this.create_access_days = true
        this.setStatusAccessProfileModal(true)
        this.setStatusEditAccessDay(false)
        this.access_day_view = []
        this.access_profile_view = {}
        this.access_profile_view = { authorized_type_id: this.authorized_type_id, department_id: this.department_id }
        // } else {
        // this.$toast('fill_responsible', 3)
        // }
      },
      closeForm () {
        if (this.is_main) this.resetForm()
        this.setStatusEditAccessDay(false)
        this.setStatusAccessProfileModal(false)
        this.edit = false
      },
      getData () {
        return new Promise((resolve, reject) => {
          this.retrieveData({ authorization_id: this.$route.params.id, profile_id: this.shard.profile_id })
            .then((res) => {
              if (res.status === 200) {
                resolve(200)
                this.authorized_types = res.data.authorized_type
                this.profiles = res.data.profiles
                this.access_credentials = res.data.credentials
                this.identification_types = res.data.document_types
                this.visited = res.data.visited
                this.departments = res.data.departments
                this.access_profiles = res.data.access_profile
                this.cargo_vehicle_type = res.data.cargo_vehicle_type
                this.user_profiles = res.data.user_profiles
                setTimeout(() => {
                  window.$('.m_selectpicker').selectpicker('refresh')
                }, 100)
              }
            })
            .catch((err) => {
              this.$toast('error_loading_form', 4)
              console.log(err)
              resolve(400)
            })
        })
      },
      cargo_vehicles (value) {
        const cargo = this.cargo_vehicle_type.find(cargo_vehicle => cargo_vehicle.id === value && cargo_vehicle.name === 'articulate')
        cargo ? this.is_articulate = true : this.is_articulate = false
        this.cargo_cars.cargo_vehicle_type = ''
      },
      addCar () {
        this.own_cars.push({ license_plate: '' })
      },
      dropCar (index) {
        this.own_cars.splice(index, 1)
      },
      addCredential () {
        let length = this.authorized_credentials.length
        if (length < this.access_credentials.length) {
          this.authorized_credentials.push({ credential_id: 0, value: '', idx: length })
        } else {
          this.$toast('maximum_credentials_reached', 3)
        }
      },
      dropCredential (index) {
        this.authorized_credentials.splice(index, 1)
      },
      accessProfile (name) {
        return name.startsWith('personalized-')
      },
      docExpiration (id_doc, k, evt) {
        this.errors.remove(`expires_doc_${k}`)
        this.autho.doc_auth_types[k].document_id = id_doc
      },
      uniqueCredential (value, credential_id) {
        if (value.length >= 1) {
          service.post('/api/person/check-credential', this.$store, { value: value, credential_id: credential_id, id: this.autho.person_id ? this.autho.person_id : '' })
            .then((response) => {
              if (!response.data.valid) {
                swal({
                  type: 'warning',
                  html: this.$options.filters.capitalize('credential_already_assigned'),
                  showConfirmButton: false,
                  timer: 5000
                })
              }
            })
        }
      },
      showAccessProfile () {
        const access_profile = this.access_profiles.find(ap => ap.id === this.autho.access_profile_id)
        if (access_profile) {
          this.edit_outside = access_profile.is_personalized === 1
        }
      },
      infoModal () {
        const access_profile = this.access_profiles.find(ap => ap.id === this.autho.access_profile_id)
        if (access_profile) {
          this.access_profile_view = access_profile
          this.access_day_view = access_profile.access_day
          this.edit_outside = access_profile.is_personalized === 1
          this.create_access_days = false
          this.setStatusAccessProfileModal(true)
          this.setStatusEditAccessDay(true)
        }
      },
      createPersonalizeds () {
        let data_complete = {}
        Object.assign(data_complete, this.autho.access_profile, {authorized_type_id: this.autho.authorized_type_id, department_id: this.autho.department_id})
        this.$store.dispatch('saveAccessProfile', {access_profile: data_complete})
          .then((result) => {
            this.autho.access_profile_id = result.data.access_profile.id
            this.autho.undefined_date ? this.autho.end_date = '' : ''
            if (this.autho.authorized_type_id === 1 || this.autho.authorized_type_id === 2) {
              this.autho.is_responsible = true
            }
            this.editAuthorization(this.autho)
              .then((resp) => {
                this.$spinner.remove()
                if (resp.data.vehicle_replace) {
                  this.$toast('vehicle_replaced', 2)
                }
                this.$toast('edit_authorization_message')
                this.is_cargo_prop ? this.$router.push({ name: 'showStaffCargo' }) : this.$router.push({ name: 'showStaffCond' })
              })
              .catch((err) => {
                this.$spinner.remove()
                this.$toast('edit_authorization_error', 4)
                console.log(err)
              })
          })
          .catch((err) => {
            this.$toast('access_profile_error', 4)
            console.log(err)
          })
      },
      validate () {
        this.autho.own_cars = this.own_cars
        if (this.is_cargo) this.autho.cargo_cars = this.cargo_cars
        this.autho.is_cargo = this.is_cargo
        this.autho.is_responsible = this.is_responsible
        if (!this.autho.is_responsible) this.autho.position = ''
        this.autho.is_operator = this.is_operator
        if (!this.autho.is_operator) this.profile_operator = ''
        this.autho.authorized_credentials = this.authorized_credentials
        this.$spinner.show()
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.autho.access_profile_id === '-1') {
              // Obliga al usuario a seleccionar y guardar los dias de acceso
              if (this.autho.access_day !== undefined && this.autho.access_profile.value !== undefined) {
                // Crear perfil personalizado
                this.createPersonalizeds()
              } else {
                this.$spinner.remove()
                swal({
                  type: 'error',
                  title: this.$options.filters.capitalize('complete_access_data'),
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            } else {
              this.autho.undefined_date ? this.autho.end_date = '' : ''
              this.editAuthorization(this.autho)
                .then((resp) => {
                  this.$spinner.remove()
                  if (resp.data.vehicle_replace) {
                    this.$toast('vehicle_replaced', 2)
                  }
                  this.$toast('edit_authorization_message')
                  this.is_cargo_prop ? this.$router.push({ name: 'showStaffCargo' }) : this.$router.push({ name: 'showStaffCond' })
                })
                .catch((err) => {
                  this.$spinner.remove()
                  this.$toast('edit_authorization_error', 4)
                  console.log(err)
                })
            }
          } else {
            this.$spinner.remove()
          }
        })
      },
      startDate (value) {
        this.$set(this.config.end, 'startDate', value)
        if (this.autho.start_date.replace(':', '') > this.autho.end_date.replace(':', '')) {
          this.autho.end_date = this.autho.start_date
        }
      },
      endDate (value) {
        this.$root.$emit('date_expiration', value)
      },
      // checkRange (value) {
      //   if (this.range_time !== '' && this.range_time !== null) {
      //     let start = moment(this.autho.start_date)
      //     let end = moment(value)
      //     let dif = end.diff(start, 'days')
      //     if (dif <= parseInt(this.range_time)) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   } else {
      //     return true
      //   }
      // },
      back () {
        this.is_cargo_prop ? this.$router.push({ name: 'showStaffCargo' }) : this.$router.push({ name: 'showStaffCond' })
      },
      departureOrder () {
        if (this.departure_order !== '') {
          this.$spinner.show()
          this.generateDepartureOrder({departure_order: this.departure_order, company_id: this.autho.company_id, authorization_id: this.autho.id, person_id: this.autho.person_id})
            .then((res) => {
              this.$spinner.remove()
              this.$toast('departure_order_generated')
            })
            .catch((err) => {
              this.$toast('departure_order_error', 4)
              this.$spinner.remove()
              console.log(err)
            })
        } else {
          this.$toast('fill_departure_order', 3)
        }
      },
      removeAuthorization () {
        this.$confirmation('attention', 'confirm_remove_authorization_message')
          .then((res) => {
            if (res.value) {
              this.$spinner.show()
              this.changeAuthorization({authorization_id: this.autho.id, state: 0, person_id: this.autho.person_id, identification_number: this.autho.identification_number, email: this.autho.email})
                .then((res) => {
                  this.$router.push({ name: 'showStaffCargo' })
                  this.$spinner.remove()
                })
                .catch((err) => {
                  console.log(err)
                  this.$toast('error_remove_authorization', 4)
                  this.$spinner.remove()
                })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      recoverAuthorization () {
        this.$spinner.show()
        this.getData()
          .then((res) => {
            if (res === 200) {
              this.showAuthorization(this.$route.params.id)
                .then((res) => {
                  if (res.status === 200) {
                    res.data.display_departure_order === 'true' ? this.display_departure_order = true : this.display_departure_order = false
                    this.autho = res.data.authorization
                    this.autho.person_id = res.data.authorization.person.id
                    this.autho.first_name = res.data.authorization.person.first_name
                    this.autho.last_name = res.data.authorization.person.last_name
                    this.autho.email = res.data.authorization.person.email
                    this.autho.identification_number = res.data.authorization.person.identification_number
                    this.autho.is_dni_generated = res.data.authorization.person.is_dni_generated
                    this.autho.identification_type = res.data.authorization.person.identification_type
                    this.access_profile_view = res.data.authorization.access_profile
                    this.autho.authorized_type_id = res.data.authorization.access_profile.authorized_type_id
                    this.$root.$emit('authorized_type_id', this.autho.authorized_type_id)
                    this.autho.department_id = res.data.authorization.access_profile.department_id
                    this.autho.access_profile_id = res.data.authorization.access_profile.id
                    this.autho.access_profile_personalized = res.data.authorization.access_profile.is_personalized
                    this.autho.authorized_type_responsible = res.data.authorization.access_profile.authorized_type.is_responsible
                    this.autho.authorized_type_operator = res.data.authorization.access_profile.authorized_type.is_operator
                    this.autho.doc_auth_types = this.autho.person_documents
                    // this.authorized_credentials = this.autho.person_credentials.filter((credential) => credential.credential.add_in_reception === 0)
                    this.authorized_credentials = this.autho.person_credentials.filter((credential) => credential.credential_id !== 7)
                    this.own_cars = this.autho.person_vehicles
                    this.cargo_cars = this.autho.cargo_vehicles[0]
                    this.is_cargo = this.autho.is_cargo === 1
                    this.disabled = 0
                    this.is_responsible = res.data.authorization.person.is_responsible
                    this.is_operator = res.data.authorization.person.is_operator
                    this.autho.own_fleet = res.data.authorization.own_fleet
                    this.autho.position = res.data.authorization.person.position
                    this.autho.profile_operator = res.data.authorization.profile_operator
                    this.isTraining = res.data.elements[0].value
                    // this.range_time = res.data.range_time
                    delete this.autho.person
                    delete this.autho.person_documents
                    delete this.autho.person_vehicles
                    delete this.autho.person_credentials
                    delete this.autho.cargo_vehicles
                    // if (this.autho.end_date === '') {
                    //   this.autho.end_date = moment().format('YYYY-MM-DD')
                    // }
                    if (res.data.departure_order) {
                      this.generate_departure = false
                      this.departure_order = res.data.departure_order.departure_order
                    } else {
                      this.generate_departure = true
                    }
                    this.idx_department = this.departments.findIndex(department => department.id === this.autho.department_id)
                    this.retrieveData({ authorized_type_id: this.autho.authorized_type_id })
                      .then((res) => {
                        if (res.status === 200) {
                          this.doc_types = res.data.doc_auth_type
                          this.show_expirations = true
                          this.$spinner.remove()
                        }
                      })
                      .catch((err) => {
                        this.$spinner.remove()
                        console.log(err)
                      })
                    this.checkPersonTemplate({person_dni: this.autho.identification_number})
                      .then((res) => {
                        this.hasTemplate = res.data.result
                      })
                      .catch((err) => {
                        this.$toast('An error has been ocurred')
                        console.log(err)
                      })
                  }
                })
                .catch((err) => {
                  console.log(err)
                  this.$spinner.remove()
                })
            }
          })
      },
      expirationDate (docs) {
        for (let k in docs) {
          if (this.autho.undefined_date === false && this.autho.doc_auth_types[k].value === '') {
            this.autho.doc_auth_types[k].value = this.autho.end_date
          }
          if (this.autho.undefined_date === 0 && this.autho.doc_auth_types[k].value === '') {
            this.autho.doc_auth_types[k].value = this.autho.end_date
          }
        }
      },
      pushDocAuthTypes (doc_auth_types) {
        this.autho.doc_auth_types = []
        for (let i = 0; i < this.doc_types.length; i++) {
          this.autho.doc_auth_types.push({ document_id: '', value: '' })
        }
      },
      checkBiometricsMail (mail) {
        if (mail === '') {
          this.$toast('biometrics_mail_required', 2)
        }
      },
      translateErrorMessage (key, errorMessage) {
        let message = ''
        if (errorMessage) {
          message = errorMessage.replace(key, this.$options.filters.capitalize(key))
        }
        return message
      }
    },
    created () {
      this.getStateBiometric({data: this.shard})
        .then((res) => {
          this.showBiometric = res.data.propConfig.value
        })
        .catch((err) => {
          this.$toast('An error has been ocurred')
          console.log(err)
        })
      this.validateAccessCredential()
      this.recoverAuthorization()
      this.setValidateEmail(this.validate_email)
      Validator.extend('uniqueEmail', {
        getMessage: field => {
          return this.$options.filters.capitalize('email_already_exists2')
        },
        // Returns a boolean value
        validate: value => {
          return this.uniqueEmail(this.autho.email, this.autho.identification_number)
        }
      })
    },
    mounted () {
      this.$root.$on('authorized_type_id', (value) => {
        this.authorized_typeid = value
      })
      this.$root.$on('date_expiration', (value) => {
        let docs = this.doc_types
        for (let k in docs) {
          if (this.autho.undefined_date === 0 || this.autho.undefined_date === false) {
            this.autho.doc_auth_types[k].value = value
          }
          if (this.autho.undefined_date === 0) {
            this.autho.doc_auth_types[k].value = this.end_date
          }
        }
      })
      // Validator.extend('rangeDays', {
      //   getMessage: field => {
      //     return this.$options.filters.capitalize('exced_range_time')
      //   },
      //   // Returns a boolean value
      //   validate: value => {
      //     return this.checkRange(value)
      //   }
      // })
    },
    watch: {
      modal_access_profile (newVal, oldVal) {
        if (this.edit_outside && oldVal === true && newVal === false) {
          this.recoverAuthorization()
        }
      },
      validate_email (newVal, oldVal) {
        this.$validator.validate().then(result => {})
      },
      changeUndefined (newVal, oldVal) {
        if (newVal === false) {
          if (this.autho.doc_auth_types.length < 1) {
            this.pushDocAuthTypes()
          }
          if (this.autho.end_date === '') {
            this.autho.end_date = this.autho.start_date
            this.endDate(this.autho.end_date)
          }
        }
        if (newVal === 0) {
          if (this.autho.doc_auth_types.length < 1) {
            this.pushDocAuthTypes()
          }
          if (this.autho.end_date === '') {
            this.autho.end_date = this.autho.start_date
            this.endDate(this.autho.end_date)
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .doc_expiration {
    margin: 3px !important;
  }
  .actions {
    text-align: right;
  }
  .actions > button {
    min-width: 140px;
  }
  .checks {
    border: 0 !important;
  }
  div.m-checkbox-inline-form-wizard {
    margin: 10px 0 10px 0 !important;
  }
  .checkbox-form-wizard {
    margin: 20px !important;
  }
  .badge-notification {
    border-radius: 60px;
    background-color: #D73925;
  }
  .container-vehicle {
    margin-bottom: 20px !important;
  }
  </style>
  


// WEBPACK FOOTER //
// Edit.vue